import React, { useContext } from "react";
import { BookOpenIcon } from "@heroicons/react/solid";
import SectionHeader from "../../partials/SectionHeader";
import EducationTile from "../../partials/EducationTile";
import { DataContext } from "../../../data";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

export default function Education() {
  const { home, educations } = useContext(DataContext);
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="testimonials">
      <div className="container px-5 py-5 mx-auto text-center lg:px-40">
        <SectionHeader title={home.education.title} description={home.education.description} icon={<BookOpenIcon />} />
        <div ref={ref} className={`flex flex-wrap -m-4 scroll-reveal${isVisible ? ' visible' : ''}`}>
          {educations.map((education) => (
            <EducationTile key={`${education.course}`} {...{education}} />
          ))}
        </div>
      </div>
    </section>
  );
}